"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopUpButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const exchange_1 = require("@framework/exchange");
const constants_1 = require("@framework/constants");
const topUp_json_1 = __importDefault(require("@framework/abis/json/TopUp/topUp.json"));
const utils_1 = require("../../../utils");
const dialogs_1 = require("../../../dialogs");
const dialog_1 = require("./dialog");
const TopUpButton = (props) => {
    const { className, contract, contract: { address }, disabled, variant, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { execute: metaFnWithAllowance } = (0, react_hooks_eth_1.useAllowance)(async (values) => {
        const asset = values.token.components[0];
        if (asset.tokenType === types_1.TokenType.NATIVE) {
            return writeContractAsync({
                address: address,
                abi: topUp_json_1.default,
                functionName: "topUp",
                args: [
                    [
                        {
                            tokenType: 0,
                            token: constants_1.ZeroAddress,
                            tokenId: 0,
                            amount: asset.amount,
                        },
                    ],
                    { value: BigInt(asset.amount) },
                ],
            });
        }
        else if (asset.tokenType === types_1.TokenType.ERC20) {
            return writeContractAsync({
                address: address,
                abi: topUp_json_1.default,
                functionName: "topUp",
                args: [
                    [
                        {
                            tokenType: 1,
                            token: asset.contract.address,
                            tokenId: 0,
                            amount: asset.amount,
                        },
                    ],
                ],
            });
        }
        else {
            throw new Error("unsupported token type");
        }
    });
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)((values) => {
        const assets = (0, exchange_1.convertDatabaseAssetToTokenTypeAsset)(values.token.components);
        return metaFnWithAllowance({
            contract: values.address,
            assets,
        }, values);
    });
    const handleTopUpConfirm = async ({ data }) => {
        await metaFn(data);
    };
    const handleTopUp = () => {
        openDialog(dialogs_1.GlobalDialogKeys.TOP_UP, contract, {
            initialValues: {
                token: (0, mui_inputs_asset_1.getEmptyToken)(),
                address,
            },
            validationSchema: dialog_1.topUpValidationSchema,
            message: "dialogs.topUp",
            testId: "TopUpForm",
            onExternalConfirm: handleTopUpConfirm,
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleTopUp, icon: icons_material_1.MonetizationOn, message: "form.buttons.topUp", className: className, dataTestId: "TopUpButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract), variant: variant }));
};
exports.TopUpButton = TopUpButton;
//# sourceMappingURL=index.js.map